import { mxEvent, MxGraphNS, mxConstants, mxGraphSelectionModel, mxEventSource } from "@edp-pmf/mxgraph-ts";
import { BpmnModel } from "@edp-pmf/bpmn-model";
import { ProcessInstance } from "./entity/ProcessInstance";
import { ActivityInstanceSlim } from "./entity/ActivityInstanceSlim";
import { TransitionInstanceSlim } from "./entity/TransitionInstanceSlim";
import { UIFlowchartComponent } from "../task-flowchart/task-flowchart.component";
import { FlowGraph } from "./FlowGraph";
import { CellStyleConfig } from "../entity/cell-style/CellStyleConfig";


export class FlowChart extends mxEventSource {
    ngComp: UIFlowchartComponent;
    container: HTMLDivElement;
    graph: FlowGraph;
    diagramContainer: HTMLDivElement;
    button: HTMLButtonElement;
    resizeHandler: () => void;

    mode: 'complete' | 'simulation' = 'complete';
    processInstance: ProcessInstance;
    bpmnModel: BpmnModel;
    actList: ActivityInstanceSlim[] = [];
    transInsList: TransitionInstanceSlim[] = [];
    rootPath: string = '';//基路径
    /**
     * 当前语言
     */
    langCode = (window as any).gspframeworkService && (window as any).gspframeworkService.rtf.language.getLanguageCode() || localStorage.getItem('languageCode') || 'zh-CHS';

    constructor(container: any, config: CellStyleConfig) {
        super();
        try {
            this.rootPath = (window as any).gspframeworkService.common.getBasePath.get();
        } catch (error) {
        }
        this.container = container;
        this.createDiv();
        this.graph = this.createGraph(config);
        window.setTimeout(() => {
            this.resetScrollbars();
        }, 0);
        this.refresh();
        this.resizeHandler = () => {
            window.setTimeout(() => {
                if (this.graph != null) {
                    this.refresh();
                }
            }, 0);
        };
        mxEvent.addListener(window, 'resize', this.resizeHandler);

        this.graph.getSelectionModel().addListener(mxEvent.CHANGE, (sender: any, evt: MxGraphNS.mxEventObject) => {
            this.cellSelect(sender, evt);
        });
    }

    /**
     * 设置当前语言
     * @param lang
     */
    setLanguage(lang: string) {
        this.langCode = lang;
        if (this.graph) {
            this.graph.langCode = lang;
        }
    }

    switchMode({ mode, actiInstList, transInsList }) {
        this.mode = mode;
        this.actList = actiInstList;
        this.transInsList = transInsList;

        this.graph.actList = this.actList;
        this.graph.transInsList = this.transInsList;
        this.graph.mode = this.mode;
        this.graph.reloadBpmnModel();
    }

    load(data: any) {
        if (data) {
            this.processInstance = data.processInstance;
            this.actList = data.actiInstList;
            this.transInsList = data.transInsList;
            this.mode = data.mode;

            this.graph.actList = this.actList;
            this.graph.transInsList = this.transInsList;
            this.graph.mode = this.mode;
            this.graph.loadBpmnModel(data.content);
            this.resetScrollbars();

        }
    }

    createDiv() {
        this.diagramContainer = document.createElement('div');
        this.diagramContainer.className = 'flowChartContainer';

        this.container.appendChild(this.diagramContainer);
        setTimeout(() => {
            // this.diagramContainer.style.overflow = 'hidden';

            mxEvent.addListener(this.diagramContainer, 'mouseover', () => {
                // this.diagramContainer.style.overflow = 'auto';
                this.diagramContainer.classList.add('active');
            });
            mxEvent.addListener(this.diagramContainer, 'mouseleave', () => {
                // this.diagramContainer.style.overflow = 'hidden';
                this.diagramContainer.classList.remove('active');
            });
        }, 0);

        const buttonIn = document.createElement('a');
        buttonIn.setAttribute('href', 'javascript:void(0);');
        let buttonInImg = document.createElement('img');
        buttonIn.style.marginRight = '10px';
        buttonInImg.src = this.rootPath + '/platform/runtime/common/web/@gsp-wf/wf-process-editor/images/zoomIn.svg';
        buttonInImg.style.display = "inline-block";
        buttonInImg.style.verticalAlign = "middle";
        buttonIn.appendChild(buttonInImg);
        mxEvent.addListener(buttonIn, 'click', (evt: PointerEvent) => {
            this.graph.zoomIn();
        });

        const buttonOut = document.createElement('a');
        buttonOut.setAttribute('href', 'javascript:void(0);');
        let buttonOutImg = document.createElement('img');
        buttonOutImg.src = this.rootPath + '/platform/runtime/common/web/@gsp-wf/wf-process-editor/images/zoomOut.svg';
        buttonOutImg.style.display = "inline-block";
        buttonOutImg.style.verticalAlign = "middle";
        buttonOut.appendChild(buttonOutImg);
        mxEvent.addListener(buttonOut, 'click', (evt: PointerEvent) => {
            this.graph.zoomOut();
        });

        const zoomBar = document.createElement('div');
        zoomBar.className = 'zoomBar';
        zoomBar.style.position = 'absolute';
        zoomBar.style.top = '10px';
        zoomBar.style.right = '20px';

        zoomBar.appendChild(buttonIn);
        zoomBar.appendChild(buttonOut);

        // zoomBar.appendChild(zoom);
        this.container.appendChild(zoomBar);

    }

    createGraph(config: CellStyleConfig) {
        mxConstants.VERTEX_SELECTION_STROKEWIDTH = 1;
        mxConstants.VERTEX_SELECTION_COLOR = '#0000CD';
        mxConstants.VERTEX_SELECTION_DASHED = true;

        const graph = new FlowGraph(this.diagramContainer, config);
        // 创建无限大画布
        graph.createInfiniteCanvas();
        // 创建后需要调用一次才生效
        graph.sizeDidChange();

        graph.popupMenuHandler.autoExpand = true;
        graph.popupMenuHandler.factoryMethod = (menu, cell, evt) => {
            if (cell != null
                && cell.getId().indexOf('UserActivity') > -1
                && this.actList.findIndex(a => a.activityDefinitionId === cell.getId()) > -1
                && this.processInstance) {
                const actInstId = this.actList.find(a => a.activityDefinitionId === cell.getId()).activityInstanceId;
                menu.addItem('查看单据', null, () => {
                    this.viewForm(this.processInstance.id, actInstId, this.processInstance.bizInstId);
                });
            }
            if (cell != null
                && cell.getId().indexOf('AifCreationBillActivity') > -1
                && this.actList.findIndex(a => a.activityDefinitionId === cell.getId()) > -1
                && this.processInstance) {
                // 筛选状态是Running的自动生单活动实例
                const actInsts = this.actList.filter(a => a.activityDefinitionId === cell.getId() && a.state == "RUNNING");
                if (actInsts.length == 1) {
                    const actInst = actInsts[0];
                    menu.addItem('重试', null, () => {
                        this.retryAifCreation(this.processInstance.id, actInst.activityInstanceId, this.processInstance.bizInstId);
                    });
                }
            }
        };

        return graph;
    }

    cellSelect(sender, evt: MxGraphNS.mxEventObject) {
        if (!(sender instanceof mxGraphSelectionModel)) {
            return;
        }
        const selectedCell = sender.cells[0];
        if (selectedCell) {
            if (selectedCell.vertex) {
                const selectId = selectedCell.getId();
                // 选中子流程节点时，弹出子流程图
                if (selectId && selectId.indexOf('CallActivitySubProcess') > -1
                    && this.actList.findIndex(a => a.state !== 'FORECAST'
                        && a.activityDefinitionId === selectId) > -1
                ) {
                    const actInsts = this.actList.filter(a => a.state !== 'FORECAST' && a.activityDefinitionId === selectId);
                    const activeInst = actInsts.find(a => a.state === 'RUNNING');
                    if (activeInst) {
                        this.viewChildProcessChart(activeInst);
                    } else {
                        this.viewChildProcessChart(actInsts[0]);
                    }
                } else {
                    this.ngComp.viewLogs({ type: 'activity', actiDefId: selectedCell.id });
                }
            } else {
                this.ngComp.viewLogs({ type: 'sequence' });
            }
        } else {
            this.ngComp.viewLogs({ type: 'process' });
        }
    }

    viewChildProcessChart(actInst: ActivityInstanceSlim) {
        this.ngComp.viewChild(actInst, this.processInstance);
    }

    viewForm(procInstId: string, actInstId: string, bizInstId: string) {
        this.ngComp.viewForm(procInstId, actInstId, bizInstId);
    }

    retryAifCreation(procInstId: string, actInstId: string, bizInstId: string) {
        this.ngComp.retryAifCreation(procInstId, actInstId, bizInstId);
    }

    resetScrollbars() {
        let bounds = this.graph.getGraphBounds();
        let width = Math.max(bounds.width * this.graph.view.scale, 0); // this.getScrollTileSize().width * this.graph.view.scale);
        let height = Math.max(bounds.height * this.graph.view.scale, 0); // this.getScrollTileSize().height * this.graph.view.scale);
        this.graph.container.scrollTop = Math.floor(Math.max(0, bounds.y - Math.max(20, (this.graph.container.clientHeight - height) / 2)));
        this.graph.container.scrollLeft = Math.floor(Math.max(0, bounds.x - Math.max(0, (this.graph.container.clientWidth - width) / 2)));
    }
    refresh() {
        this.resetScrollbars();
    }

    reloadBpmnModel() {
        this.graph.removeCells(this.graph.getChildCells(this.graph.getDefaultParent()));
    }
}
